const QrMojeo2MobileAppLink = 'https://moje.o2.cz/document-direct/?path=o2%2FQRmo2app.png&site=o2';

export default QrMojeo2MobileAppLink;
